module.exports = __webpack_public_path__ + "7b7ef3cc45b25a329650ddca3e26b41c.svg";